import { apolloClient } from "@/plugins/vue-apollo.js";

const changePropertyStatus = async ( variables) => {
    let responseFromApi = await apolloClient.mutate({
        mutation: require("@/landlord/api/mutations/change_property_status.graphql"),
        variables:variables ,
    }).catch((error) => {
        throw error;
    })
    return responseFromApi;

};

export { changePropertyStatus };
